module.exports = __webpack_public_path__ + "img/6.4d5c8ed0.png";